globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};

$(document).on('ready', function() {
  var $body = $('body'),
      controller = $body.data('js-controller') != '' ? $body.data('js-controller') : undefined;

  if(controller) {
    var default_namespace = appCustomerSpace.Controllers;
    try { var namespace = (controller.namespace || '').split('/').reduce(function(memo, k) { return memo[k] }, default_namespace) || default_namespace; } catch(e) { namespace = default_namespace }

    if(namespace[controller.name] instanceof Function) {
      appCustomerSpace.currentController = new namespace[controller.name];
    }

    if(controller.actions && controller.actions.length > 0) {
      controller.actions.forEach(function(actionConfig) {
        var actionName = actionConfig.action;
        var actionParams = actionConfig.params || {};
        if(appCustomerSpace.currentController[actionName] instanceof Function) {
          appCustomerSpace.currentController[actionName](actionParams);
        }
      });
    } else if(controller.action) {
      var actionParams = controller.action_params || {};
      appCustomerSpace.currentController[controller.action](actionParams);
    }
  }
});
